import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import biometric from "../../../Assets/Images/biometric.svg";
import gps from "../../../Assets/Images/gps.svg";
import qr from "../../../Assets/Images/qr-code.svg";
import rightimg from "../../../Assets/Images/right.svg";
import selfie from "../../../Assets/Images/selfie-img.svg";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Select from "react-select";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Cookies from "js-cookie";

const EditAttendanceDetail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl, selectedStaff, openToast } = useGlobalContext();
  const [flexibleDays, setFlexibleDays] = useState([]);
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [toogleStaffAttendance, setToogleStaffAttendance] = useState(
    selectedStaff?.staffDetails?.status || false
  );
  const [toggleSelfieAttendance, setToggleSelfieAttendance] = useState(
    selectedStaff?.staffDetails?.AttendenceMode?.selfie_attendance || false
  );
  const [toggleAllowPunchInMobile, setToggleAllowPunchInMobile] = useState(
    selectedStaff?.staffDetails?.AttendenceMode?.allow_punch_in_for_mobile ||
    false
  );
  const [toggleQRAttendance, setToggleQRAttendance] = useState(
    selectedStaff?.staffDetails?.AttendenceMode?.qr_attendance || false
  );
  const [toggleGPSAttendance, setToggleGPSAttendance] = useState(
    selectedStaff?.staffDetails?.AttendenceMode?.gps_attendance || false
  );
  const [markLocation, setMarkLocation] = useState(
    selectedStaff?.staffDetails?.AttendenceMode?.mark_attendance || "Office"
  );
  // console.log(markLocation, toggleAllowPunchInMobile, toggleGPSAttendance, toggleQRAttendance, toggleSelfieAttendance);
  const [openWeekDay, setOpenWeekDay] = useState("");
  const [shiftType, setShiftType] = useState("fixed");
  const parseTimeString = (timeString) => {
    // Check if the timeString is valid and formatted correctly
    if (!timeString || !timeString.includes(" hr : ")) {
      return { hr: "", min: "" };
    }
    const [hr, min] = timeString.split(" hr : ").map((val) => val.trim());
    return { hr, min: min.split(" ")[0] };
  };

  const [toggleAutoPresent, setToggleAutoPresent] = useState(
    selectedStaff?.staffDetails?.attendanceAutomationRule?.auto_absent || false
  );
  const [togglePresentOnPunch, setTogglePresentOnPunch] = useState(
    selectedStaff?.staffDetails?.attendanceAutomationRule?.present_on_punch ||
    false
  );

  const [autoHalfDay, setAutoHalfDay] = useState(
    parseTimeString(
      selectedStaff?.staffDetails?.attendanceAutomationRule?.auto_half_day
    )
  );
  const [mandatoryFullDayHour, setMandatoryFullDayHour] = useState(
    parseTimeString(
      selectedStaff?.staffDetails?.attendanceAutomationRule?.manadatory_full_day
    )
  );

  const handleMonthChange = (e) => {
    setSelectedMonth(new Date(e.target.value));
  };
  const [mandatoryHalfDayHour, setMandatoryHalfDayHour] = useState(
    parseTimeString(
      selectedStaff?.staffDetails?.attendanceAutomationRule?.manadatory_half_day
    )
  );
  const [shiftDetails, setShiftDetails] = useState(
    selectedStaff?.staffDetails?.shifts || []
  );
  console.log(shiftDetails, "shiftDetails")

  const [selectMonShift, setSelectMonShift] = useState([]);
  const [selectTueShift, setSelectTueShift] = useState([]);
  const [selectWedShift, setSelectWedShift] = useState([]);
  const [selectThuShift, setSelectThuShift] = useState([]);
  const [selectFriShift, setSelectFriShift] = useState([]);
  const [selectSatShift, setSelectSatShift] = useState([]);
  const [selectSunShift, setSelectSunShift] = useState([]);
  const selectAttendanceDetail = selectedStaff;
  console.log(selectAttendanceDetail?.staffDetails?.FixedShift[0]?.shifts[0]);
  const [hasWeekOff, setHasWeekOff] = useState({
    MonWeekOff: false,
    TueWeekOff: false,
    WedWeekOff: false,
    ThuWeekOff: false,
    FriWeekOff: false,
    SatWeekOff: false,
    SunWeekOff: false,
  });

  // all shift weeks
  const [weekoff, setWeekOff] = useState({
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false,
    Sun: false,
  });
  console.log(weekoff?.Sun, "weekoff");

  const [Shift, setShift] = useState({
    shiftOne: [],
    shiftTwo: [],
    shiftThree: [],
    shiftFour: [],
    shiftFive: [],
    shiftSix: [],
    shiftSeven: [],
  });

  console.log(Shift, "Shift");
  const [weekName, setWeekName] = useState("");

  const [modalIsOpen22, setIsOpen22] = React.useState(false);
  function openModal22() {
    setIsOpen22(true);
  }
  function afterOpenModal22() {
    subtitle.style.color = "#000";
  }

  const [selectedWeeks, setSelectedWeeks] = useState({
    Mon: "",
    Tue: "",
    Wed: "",
    Thu: "",
    Fri: "",
    Sat: "",
    Sun: "",
  }); // To store selected weeks

  function closeModal22() {
    setIsOpen22(false);
  }
  const [allWeeksSelected, setAllWeeksSelected] = useState(false);
  const handleAllWeeksToggle = () => {
    const newStatus = !allWeeksSelected;
    setAllWeeksSelected(newStatus);
    setWeeks({
      firstWeek: newStatus,
      secondWeek: newStatus,
      thirdWeek: newStatus,
      fourthWeek: newStatus,
      fifthWeek: newStatus,
    });
  };

  const [weeks, setWeeks] = useState({
    firstWeek: false,
    secondWeek: false,
    thirdWeek: false,
    fourthWeek: false,
    fifthWeek: false,
  });

  const handleWeekToggle = (week) => {
    const updatedWeeks = {
      ...weeks,
      [week]: !weeks[week],
    };
    setWeeks(updatedWeeks);

    // Check if all weeks are selected after this update
    const allSelected = Object.values(updatedWeeks).every(
      (selected) => selected
    );
    setAllWeeksSelected(allSelected);
  };

  const handleConfirm2 = () => {
    const selectedDay = weekName.slice(0, 3); // Extract day abbreviation (e.g., 'Mon', 'Tue')

    // Find the current day in the dayWiseWeekOff array
    const currentDay = dayWiseWeekOff.find((day) => day.day === selectedDay);

    // Check if all weeks are selected
    const allWeeksSelected = Object.values(weeks).every(
      (week) => week === true
    );

    if (currentDay) {
      // Filter out selected weeks (those that are true)
      const selectedWeek = Object.keys(weeks)
        .map((week, index) => {
          const weekIndex = index + 1; // Adjust for 1-based index
          const weekSuffix =
            weekIndex === 1
              ? "st"
              : weekIndex === 2
                ? "nd"
                : weekIndex === 3
                  ? "rd"
                  : "th";

          // Check if the week is selected (true) or not (false)
          return {
            weekIndex,
            weekSuffix,
            isSelected: weeks[week], // true or false based on whether the week is selected
          };
        })
        .filter(({ isSelected }) => isSelected) // Only keep selected weeks (true)
        .map(({ weekIndex, weekSuffix }) => {
          // Return the formatted week with the suffix
          return `${weekIndex}${weekSuffix}`;
        });

      // If all weeks are selected, set it to 'All Week Off'
      const weekOffText = allWeeksSelected
        ? `All ${weekName} Week Off`
        : selectedWeek.length > 0
          ? `${selectedWeek.join(", ")} Week is Off`
          : "";

      // Update selectedWeeks with the selected week(s)
      setSelectedWeeks((prevSelectedWeeks) => {
        // Find the index of the selectedDay in the current selectedWeeks object
        const selectedDayKey = selectedDay; // The key should be the abbreviation (e.g., "Mon")

        if (prevSelectedWeeks[selectedDayKey]) {
          // If the day is already in the selectedWeeks, update the week off info
          return {
            ...prevSelectedWeeks,
            [selectedDayKey]: weekOffText, // Update the info for that day
          };
        } else {
          // If the day isn't found in selectedWeeks, simply add it
          return {
            ...prevSelectedWeeks,
            [selectedDayKey]: weekOffText, // Add the entry
          };
        }
      });
    }

    // Update dayWiseWeekOff by finding the index of the selectedDay and updating the entry
    setDayWiseWeekOff((prevDayWiseWeekOff) => {
      // Find the index of the selectedDay in the current dayWiseWeekOff array
      const index = prevDayWiseWeekOff.findIndex(
        (day) => day.day === selectedDay
      );

      const weekOffText = allWeeksSelected
        ? "All Week Off"
        : Object.keys(weeks)
          .filter((week) => weeks[week]) // Only selected weeks (true)
          .map((week, index) => {
            const weekIndex = index + 1;
            const weekSuffix =
              weekIndex === 1
                ? "st"
                : weekIndex === 2
                  ? "nd"
                  : weekIndex === 3
                    ? "rd"
                    : "th";
            return `${weekIndex}${weekSuffix}`;
          })
          .join(", ") + " Week is Off";

      if (index !== -1) {
        // If found, update the entry at that index
        return prevDayWiseWeekOff.map((day, idx) =>
          idx === index
            ? { ...day, weekOff: weeks, weekOffText } // Add the text for "All Week Off" or selected weeks
            : day
        );
      } else {
        // If the day isn't found, add a new entry at the end
        return [
          ...prevDayWiseWeekOff,
          { day: selectedDay, weekOff: weeks, weekOffText },
        ];
      }
    });

    // Reset the weeks state to false (indicating no weeks are selected)
    setWeeks({
      firstWeek: false,
      secondWeek: false,
      thirdWeek: false,
      fourthWeek: false,
      fifthWeek: false,
    });

    // Reset the allWeeksSelected state to false (if it's being tracked)
    setAllWeeksSelected(false);

    // Close the modal after confirming
    closeModal22();
  };

  // all shift weeks

  const [dayWiseWeekOff, setDayWiseWeekOff] = useState([
    {
      day: "Mon",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Tue",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Wed",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Thu",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Fri",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Sat",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Sun",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
  ]);
  const weekLabels = {
    firstWeek: "1st",
    secondWeek: "2nd",
    thirdWeek: "3rd",
    fourthWeek: "4th",
    fifthWeek: "5th",
  };
  const [openCalendar, setOpenCalendar] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [year, setYear] = useState(new Date().getFullYear());

  const months = [
    ["Jan", "Feb", "Mar"],
    ["Apr", "May", "Jun"],
    ["Jul", "Aug", "Sep"],
    ["Oct", "Nov", "Dec"],
  ];

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  };

  const handleMonthSelect = (monthIdx) => {
    const newDate = new Date(year, monthIdx);
    setSelectedMonth(newDate);
    setOpenCalendar(false);
  };

  const handleYearChange = (increment) => {
    setYear(year + increment);
  };

  // console.log(selectedMonth);

  const getWeekOffSummaryForDay = (day) => {
    const selectedDay = dayWiseWeekOff.find((item) => item.day === day);
    if (!selectedDay) {
      return `Invalid day: ${day}`;
    }

    const { weekOff } = selectedDay;
    const weeksOff = Object.entries(weekOff)
      .filter(([_, isOff]) => isOff)
      .map(([weekKey]) => weekLabels[weekKey])
      .join(", ");

    return `${day}: ${weeksOff ? `${weeksOff} Week Off` : "All Week off"}`;
  };
  const handleDayWeekOffChange = (day, week, checked) => {
    setDayWiseWeekOff((prevState) => {
      // Update the specific day and week within the `dayWiseWeekOff` array
      const updatedDayWiseWeekOff = prevState.map((item) => {
        if (item.day === day) {
          return {
            ...item,
            weekOff: {
              ...item.weekOff,
              [week]: checked, // Update the selected week for the day
            },
          };
        }
        return item;
      });
      return updatedDayWiseWeekOff;
    });
  };

  // console.log(dayWiseWeekOff);
  async function fetchShiftDetails() {
    const result = await fetch(baseUrl + "shift", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    });
    if (result.status == 200) {
      const data = await result.json();
      setShiftDetails(data);
    } else {
      openToast("No Record Found");
    }
  }

  const [openWeekOff, setOpenWeekOff] = useState(false);
  const [newShift, setNewShift] = useState({
    shiftName: "",
    shiftStartTime: "",
    shiftEndTime: "",
    punchInType: "ANYTIME",
    punchOutType: "ANYTIME",
    allowPunchInHours: 0,
    allowPunchInMinutes: 0,
    allowPunchOutHours: 0,
    allowPunchOutMinutes: 0,
  });

  const [selectedShift, setSelectedShift] = useState([]);
  const options = selectedShift?.map((seo) => ({
    value: seo?.shiftName,
    label: `${seo?.shiftName} | ${seo?.shiftStartTime} - ${seo?.shiftEndTime}`,
  }));
  const isSelected = (shiftId) => selectedShift.some((s) => s.id === shiftId);
  console.log(selectedStaff);
  async function updateAttendanceMode(e) {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      staff_ids: [selectedStaff?.staffDetails?.id],
      attendence_mode: {
        selfie_attendance: toggleSelfieAttendance,
        qr_attendance: toggleQRAttendance,
        gps_attendance: toggleGPSAttendance,
        mark_attendance: markLocation,
        allow_punch_in_for_mobile: toggleAllowPunchInMobile,
      },
    };

    try {
      const response = await fetch(baseUrl + "attendance/mode/", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (response.status === 200) {
        console.log(result);
        openToast(
          "Attendance Mode created and updated Successfully",
          "success"
        );
      } else {
        openToast(
          "An error occurred while creating and updating attendance mode",
          "error"
        );
      }
    } catch (error) {
      console.error("Error creating and updating attendance mode:", error);
      openToast(
        "An error occurred while creating and updating attendance mode",
        "error"
      );
    } finally {
      closeModal5();
      openModal6();
      setIsLoading(false);
    }
  }

  async function updateAttendanceAutomationRules(e) {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      staff_ids: [selectedStaff?.staffDetails?.id],
      automation_rules: {
        auto_absent: toggleAutoPresent,
        present_on_punch: togglePresentOnPunch,
        auto_half_day:
          autoHalfDay.hr && autoHalfDay.min
            ? `${autoHalfDay.hr} hr : ${autoHalfDay.min} min`
            : "Not Set",
        mandatory_half_day: `${mandatoryHalfDayHour.hr} hr : ${mandatoryHalfDayHour.min} min`,
        mandatory_full_day: `${mandatoryFullDayHour.hr} hr : ${mandatoryFullDayHour.min} min`,
      },
    };

    try {
      const response = await fetch(baseUrl + "attendance/automation/", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (response.status === 200) {
        console.log(result);
        openToast(
          "Attendance Automation Rules created and updated Successfully",
          "success"
        );
      } else {
        openToast(
          "An error occurred while creating and updating attendance automation rules",
          "error"
        );
      }
    } catch (error) {
      console.error(
        "Error creating and updating attendance automation rules:",
        error
      );
      openToast(
        "An error occurred while creating and updating attendance automation rules",
        "error"
      );
    } finally {
      closeModal7();
      openModal8();
      setIsLoading(false);
    }
  }

  let subtitle;
  // update work timing
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal() {
    setIsOpen(false);
  }
  // update work timing

  //update onclick shift modal
  const [modalIsOpen1, setIsOpen1] = React.useState(false);
  function openModal1() {
    setIsOpen1(true);
  }
  function afterOpenModal1() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal1() {
    setIsOpen1(false);
  }
  // update onclick shift modal

  // when onclick add shift
  const [modalIsOpen2, setIsOpen2] = React.useState(false);
  function openModal2() {
    setIsOpen2(true);
  }
  function afterOpenModal2() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal2() {
    setIsOpen2(false);
  }

  // when onclick add shift

  // onclick start timing

  const [modalIsOpen3, setIsOpen3] = React.useState(false);
  function openModal3() {
    setIsOpen3(true);
  }
  function afterOpenModal3() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal3() {
    setIsOpen3(false);
  }
  // onclick start timing

  // onclick update attendance
  const [modalIsOpen5, setIsOpen5] = React.useState(false);
  function openModal5() {
    setIsOpen5(true);
  }
  function afterOpenModal5() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal5() {
    setIsOpen5(false);
  }

  // onclick update attendance

  // toggle switch
  const [isOn, setIsOn] = useState(false);

  // const handleToggle = () => {
  //     setToogleStaffAttendance(!toogleStaffAttendance);
  //     console.log(toogleStaffAttendance);
  //     setIsOn(!isOn);
  // };
  // toggle switch

  {
    /* when onclick update attendance modes for all staff */
  }
  const [modalIsOpen6, setIsOpen6] = React.useState(false);
  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal6() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  // flexible sunday week off logic

  // const handleWeekoffToggle = (e) => {
  //   if (e.target.checked) {
  //     // Get all Sundays in the selected month
  //     const sundays = daysInMonth
  //       .map((day) => {
  //         const date = new Date(
  //           selectedMonth.getFullYear(),
  //           selectedMonth.getMonth(),
  //           day
  //         );
  //         return date.getDay() === 0 ? date.toISOString() : null;
  //       })
  //       .filter(Boolean); // Remove null values

  //     setFlexibleDays((prev) => [
  //       ...prev.filter((item) => !sundays.includes(item.day)), // Remove existing Sundays
  //       ...sundays.map((day) => ({ day, weekOff: true, shifts: [] })), // Add new Sundays
  //     ]);
  //   } else {
  //     // Remove only Sundays from flexibleDays
  //     setFlexibleDays((prev) =>
  //       prev.filter((item) => new Date(item.day).getDay() !== 0)
  //     );
  //   }
  // };

  const handleWeekoffToggle = (e) => {
    if (e.target.checked) {
      const sundays = daysInMonth
        .map((day) => {
          const date = new Date(
            selectedMonth.getFullYear(),
            selectedMonth.getMonth(),
            day
          );
          return date.getDay() === 0 ? date.toISOString() : null;
        })
        .filter(Boolean);

      setFlexibleDays((prev) => [
        ...prev.filter((item) => !sundays.includes(item.day)), // Remove existing Sundays
        ...sundays.map((day) => ({ day, weekOff: true, shifts: [] })), // Add new Sundays as weekOff
      ]);
    } else {
      setFlexibleDays((prev) =>
        prev.map((item) =>
          new Date(item.day).getDay() === 0
            ? { ...item, weekOff: false, shifts: [] } // Reset Sunday
            : item
        )
      );
    }
  };

  // flexible sunday week off logic

  function closeModal6() {
    setIsOpen6(false);
  }

  {
    /* when onclick update attendance modes for all staff */
  }

  {
    /* when onclick update automation rule for all staff */
  }
  const [modalIsOpen7, setIsOpen7] = React.useState(false);
  function openModal7() {
    setIsOpen7(true);
  }
  function afterOpenModal7() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal7() {
    setIsOpen7(false);
  }

  {
    /* when onclick update automation rule for all staff */
  }

  {
    /* when onclick update attendance modes  rule for all staff  successfull message*/
  }

  const [modalIsOpen8, setIsOpen8] = React.useState(false);
  function openModal8() {
    setIsOpen8(true);
  }
  function afterOpenModal8() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal8() {
    setIsOpen8(false);
  }

  {
    /* when onclick update attendance modes  rule for all staff  successfull message*/
  }

  //  onclick auto half day button

  const [modalIsOpen16, setIsOpen16] = React.useState(false);
  function openModal16() {
    setIsOpen16(true);
  }
  function afterOpenModal16() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal16() {
    setIsOpen16(false);
  }
  // onclick auto half day button

  // onclick mandatory half day button
  const [modalIsOpen17, setIsOpen17] = React.useState(false);
  function openModal17() {
    setIsOpen17(true);
  }
  function afterOpenModal17() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal17() {
    setIsOpen17(false);
  }
  // onclick mandatory half day button

  // onclick mandatory full day button
  const [modalIsOpen18, setIsOpen18] = React.useState(false);
  function openModal18() {
    setIsOpen18(true);
  }
  function afterOpenModal18() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal18() {
    setIsOpen18(false);
  }
  // onclick mandatory half day button

  const handleTimeChange = (value) => {
    const [hours, minutes] = value.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    const adjustedHours = hours % 12 || 12; // `12` for midnight and noon
    const formattedTime = `${adjustedHours}:${minutes < 10 ? `0${minutes}` : minutes
      } ${period}`;

    return formattedTime;
  };

  // console.log(newShift);

  const handleCheckboxChange = (shift) => {
    setSelectedShift((prevSelected) => {
      if (isSelected(shift.id)) {
        // If already selected, remove from selectedShift
        return prevSelected.filter((s) => s.id !== shift.id);
      } else {
        // Otherwise, add to selectedShift
        return [...prevSelected, shift];
      }
    });
  };
  async function submitShift() {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "shift", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(newShift),
      });

      if (result.status === 201) {
        const data = await result.json();
        openToast("Add Shift Successfully", "success");
        fetchShiftDetails();
      } else {
        openToast("An Error Occurred", "error");
      }
    } catch (error) {
      console.error("Error submitting shift:", error);
      openToast("An Unexpected Error Occurred", "error");
    } finally {
      closeModal2();
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchShiftDetails();
  }, []);
  useEffect(() => {
    setFlexibleDays([]);
  }, [selectedMonth]);

  function getMatchingShiftIds(selectedShift, selectMonShift) {
    // Map to extract labels from selectMonShift
    const selectMonShiftlabel = selectMonShift?.map((shift) => shift?.label);
    const matchingShiftIds = selectedShift
      ?.filter((shift) => {
        const label = `${shift?.shiftName} | ${shift?.shiftStartTime} - ${shift?.shiftEndTime}`;
        return selectMonShiftlabel?.includes(label); // Check if label exists in selectMonShiftlabel
      })
      ?.map((shift) => shift?.id); // Extract only the id

    return matchingShiftIds;
  }

  async function createFixedShift(e) {
    setIsLoading(true);
    const data = {
      staffId: selectedStaff?.staffDetails?.id,
      shifts: [
        {
          day: "Mon",
          weekOff: hasWeekOff.MonWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftOne),
          ...(hasWeekOff.MonWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Tue",
          weekOff: hasWeekOff.TueWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftTwo),
          ...(hasWeekOff.TueWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Wed",
          weekOff: hasWeekOff.WedWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftThree),
          ...(hasWeekOff.WedWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Thu",
          weekOff: hasWeekOff.ThuWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftFour),
          ...(hasWeekOff.ThuWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Fri",
          weekOff: hasWeekOff.FriWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftFive),
          ...(hasWeekOff.FriWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Sat",
          weekOff: hasWeekOff.SatWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftSix),
          ...(hasWeekOff.SatWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Sun",
          weekOff: hasWeekOff.SunWeekOff,
          shifts: getMatchingShiftIds(selectedShift, Shift?.shiftSeven),
          ...(hasWeekOff.SunWeekOff && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.fifthWeek,
          }),
        },
      ],
    };
    console.log(data);

    try {
      const response = await fetch(`${baseUrl}shift/fixed/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.status === 200) {
        // console.log(`Response data for ${shiftData.day}:`, result);
        openToast(`Fixed Shift Updated or Added Successfully`, "success");
      } else {
        openToast(
          `An error occurred while adding or updating Work Timing`,
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting Work Timing:", error);
      openToast(
        "An error occurred while adding or updating Work Timing",
        "error"
      );
    } finally {
      closeModal();
      setIsLoading(false);
    }
  }
  async function createFlexibleShift(e) {
    setIsLoading(true);
    const data = {
      staffId: selectedStaff?.staffDetails?.id,
      shifts: flexibleDays.map(({ day, shifts, weekOff }) => ({
        dateTime: day,
        weekOff: weekOff,
        shifts: getMatchingShiftIds(selectedShift, shifts),
      })),
    };

    // console.log(data);
    try {
      const response = await fetch(`${baseUrl}shift/flexible/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.status === 200) {
        // console.log(`Response data for ${shiftData.day}:`, result);
        openToast(`Flexible Shift Updated or Added Successfully`, "success");

        setFlexibleDays([]);
        closeModal();
      } else {
        openToast(
          `An error occurred while adding or updating Flexible Shift Work Timing`,
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting Flexible Shift Work Timing:", error);
      openToast(
        "An error occurred while adding or updating Flexible Shift Work Timing",
        "error"
      );
    } finally {
      setIsLoading(false);
      closeModal();
    }
  }

  const setDefaultWeekOffForDay = (day) => {
    setDayWiseWeekOff((prevState) => {
      const updatedDayWiseWeekOff = prevState.map((item) => {
        if (item.day === day) {
          // Set all weeks to false for the specific day
          return {
            ...item,
            weekOff: {
              allweek: false,
              firstWeek: false,
              secondWeek: false,
              thirdWeek: false,
              fourthWeek: false,
              fifthWeek: false,
            },
          };
        }
        return item;
      });
      return updatedDayWiseWeekOff;
    });
  };

  console.log(selectedMonth);
  useEffect(() => {
    const year = selectedMonth.getFullYear();
    const month = selectedMonth.getMonth();

    // Calculate days in the selected month
    const days = Array.from(
      { length: new Date(year, month + 1, 0).getDate() },
      (_, i) => i + 1
    );
    setDaysInMonth(days);
  }, [selectedMonth]);
  const getDayName = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll; // Determine the new value of selectAll
    setSelectAll(newSelectAll);
  };

  // useEffect(() => {
  //   if (!selectAttendanceDetail?.staffDetails?.FixedShift) return;

  //   const fixedShifts = selectAttendanceDetail.staffDetails.FixedShift;

  //   setShift({
  //     shiftOne: fixedShifts[0]?.shifts?.length
  //       ? fixedShifts[0].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftTwo: fixedShifts[1]?.shifts?.length
  //       ? fixedShifts[1].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftThree: fixedShifts[2]?.shifts?.length
  //       ? fixedShifts[2].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftFour: fixedShifts[3]?.shifts?.length
  //       ? fixedShifts[3].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftFive: fixedShifts[4]?.shifts?.length
  //       ? fixedShifts[4].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftSix: fixedShifts[5]?.shifts?.length
  //       ? fixedShifts[5].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],

  //     shiftSeven: fixedShifts[6]?.shifts?.length
  //       ? fixedShifts[6].shifts.map((shift) => ({
  //         label: `${shift.shiftName} | ${shift.shiftStartTime} - ${shift.shiftEndTime}`,
  //         value: shift.id,
  //       }))
  //       : [],
  //   });
  // }, []);

  return (
    <>
      <div className="relative flex flex-col xl:pt-[30px] pb-[30px] w-full">
        <div className="top-0 flex justify-between items-center bg-white p-[30px] pt-0 pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]">
          <h2 className="bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium">
            Attendance Details
          </h2>
        </div>

        <div className="mt-5">
          <button
            type="button"
            onClick={openModal}
            className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            Update Work Timings{" "}
            <ArrowForwardIosIcon className="allarrow-verify" />
          </button>

          <button
            type="button"
            onClick={openModal5}
            className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            Update Attendance Modes{" "}
            <ArrowForwardIosIcon className="allarrow-verify" />
          </button>
          <button
            type="button"
            onClick={openModal7}
            className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            Update Automation Rules{" "}
            <ArrowForwardIosIcon className="allarrow-verify" />
          </button>

          <div className="flex justify-between bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start">
            <div className="flex items-center gap-[12px]">
              <h4 className="m-0">Staff Can View Own Attendance</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={() => setToogleStaffAttendance(!toogleStaffAttendance)}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toogleStaffAttendance ? "bg-[#27004a]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toogleStaffAttendance ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* update work timing */}
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          // style={customStyles}
          contentLabel="Example Modal "
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            {" "}
            Update Work Timings
          </h2>
          <button
            onClick={closeModal}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <Tabs className="fixed-tab-section p-[s0px]">
            <TabList className="flex justify-around items-center bg-[#fff] m-2 xl:m-2 mt-3 mb-2 pt-[10px] pb-[10px] rounded-md">
              <label className="text-[14px]">Select Type</label>
              <Tab className="flex items-center gap-[10px] cursor-pointer">
                <input
                  checked={shiftType === "fixed"}
                  type="radio"
                  id="fixed"
                  name="fixed"
                  onChange={() => setShiftType("fixed")}
                  className="rounded-full"
                />
                <label for="fixed" className="text-[14px]">
                  {" "}
                  Fixed
                </label>
                <br />
              </Tab>
              <Tab className="flex items-center gap-[10px] cursor-pointer">
                <input
                  checked={shiftType === "flexible"}
                  type="radio"
                  id="flexible"
                  name="fixed"
                  onChange={() => setShiftType("flexible")}
                  className="rounded-full"
                />
                <label for="flexible" className="text-[14px]">
                  {" "}
                  Flexible
                </label>
                <br />
              </Tab>
            </TabList>
            <TabPanel>
              <div className="first-panel">
                <div className="flex justify-center items-center gap-4">
                  <h2 className="text-[14px]">Select All</h2>
                  <div className="pr-5">
                    <Select
                      options={options}
                      isMulti
                      placeholder="Select Shift"
                      value={Shift.shiftOne}
                      onChange={(selected) => {
                        console.log(selected);
                        setShift((prevShift) => ({
                          ...prevShift,
                          shiftOne: selected,
                          shiftTwo: selected,
                          shiftThree: selected,
                          shiftFour: selected,
                          shiftFive: selected,
                          shiftSix: selected,
                          // Keep Sunday unchanged unless it was manually selected before
                          shiftSeven: prevShift.shiftSeven.length > 0 ? prevShift.shiftSeven : [],
                        }));
                      }}
                      onMenuOpen={() => selectedShift?.length === 0 && openModal1()}
                      className="bg-[#fff] p-[6px] rounded-md focus-visible:outline-none w-[100%] lg:w-[240px] text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "#e5e7eb",
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "#000",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "#ff0000",
                          cursor: "pointer",
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="h-[50vh] overflow-y-scroll">
                  <table className="w-full">
                    <thead className="border-[#000] border-b">
                      <th className="p-3 font-medium text-[13px]">Day </th>
                      <th className="p-3 w-[45px] font-medium text-[13px]">
                        Weekoff{" "}
                      </th>
                      <th className="p-3 font-medium text-[13px] text-center">
                        Shifts
                      </th>
                    </thead>
                    <tbody>
                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Mon
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Monday");
                              setHasWeekOff({ ...hasWeekOff, MonWeekOff: !hasWeekOff.MonWeekOff });
                              // setIsOpen22(!modalIsOpen22);
                            }}
                            checked={hasWeekOff.MonWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff.MonWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Mon"]
                                    ? selectedWeeks["Mon"]
                                    : "No Week Off for Monday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftOne}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftOne: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>
                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Tue
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Tuesday");
                              setHasWeekOff({ ...hasWeekOff, TueWeekOff: !hasWeekOff.TueWeekOff });
                            }}
                            checked={hasWeekOff.TueWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff?.TueWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Tue"]
                                    ? selectedWeeks["Tue"]
                                    : " Week Off for Tuesday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftTwo}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftTwo: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>

                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Wed
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Wednesday");
                              setHasWeekOff({ ...hasWeekOff, WedWeekOff: !hasWeekOff.WedWeekOff });
                            }}
                            checked={hasWeekOff.WedWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff.WedWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Wed"]
                                    ? selectedWeeks["Wed"]
                                    : " Week Off for Wednesday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftThree}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftThree: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>

                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Thu
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Thursday");
                              setHasWeekOff({ ...hasWeekOff, ThuWeekOff: !hasWeekOff.ThuWeekOff });
                            }}
                            checked={hasWeekOff.ThuWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff.ThuWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Thu"]
                                    ? selectedWeeks["Thu"]
                                    : " Week Off for Thursday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftFour}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftFour: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>

                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Fri
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Friday");
                              setHasWeekOff({ ...hasWeekOff, FriWeekOff: !hasWeekOff.FriWeekOff });
                            }}
                            checked={hasWeekOff.FriWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff.FriWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Fri"]
                                    ? selectedWeeks["Fri"]
                                    : " Week Off for Friday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftFive}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftFive: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>

                      <tr className="">
                        <td className="font-normal text-[12px] text-center">
                          Sat
                        </td>
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            onChange={() => {
                              setWeekName("Saturday");
                              setHasWeekOff({ ...hasWeekOff, SatWeekOff: !hasWeekOff.SatWeekOff });
                            }}
                            checked={hasWeekOff.SatWeekOff}
                          />
                        </td>
                        <div className="flex flex-col p-[5px]">
                          {hasWeekOff.SatWeekOff ? (
                            <td className="w-[100%]">
                              <select
                                onClick={openModal22}
                                className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                              >
                                <option selected>
                                  {selectedWeeks?.["Sat"]
                                    ? selectedWeeks["Sat"]
                                    : "Week Off for Saturday"}
                                </option>
                              </select>
                            </td>
                          ) : (
                            <td className="flex items-center pr-5">
                              <Select
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={Shift.shiftSix}
                                onChange={(selected) =>
                                  setShift({ ...Shift, shiftSix: selected })
                                }
                                onMenuOpen={() =>
                                  selectedShift?.length === 0 && openModal1()
                                }
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                              <button className="bg-[#27004a] ml-4 rounded-full">
                                <AddIcon
                                  className="text-white"
                                  onClick={openModal1}
                                />
                              </button>
                            </td>
                          )}
                        </div>
                      </tr>

                      <tr className="">
                        {/* Day Column */}
                        <td className="font-normal text-[12px] text-center">Sun</td>

                        {/* Checkbox Column */}
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            checked={hasWeekOff.SunWeekOff ?? (selectedStaff?.FixedShift?.[6]?.day === "Sun" && !!selectedStaff?.FixedShift?.[6]?.weekOff)}
                            onChange={() => {
                              setHasWeekOff((prevState) => ({
                                SunWeekOff: !prevState.SunWeekOff, // Toggle WeekOff Status
                              }));
                            }}
                          />
                        </td>


                        {/* Conditional Rendering Based on hasWeekOff.SunWeekOff */}
                        {hasWeekOff.SunWeekOff ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option selected>
                                {selectedWeeks?.["Sun"] ? selectedWeeks["Sun"] : "Week Off for Sunday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftSeven}
                              onChange={(selected) => setShift({ ...Shift, shiftSeven: selected })}
                              onMenuOpen={() => selectedShift?.length === 0 && openModal1()}
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({ ...base, minHeight: "40px" }),
                                multiValue: (base) => ({ ...base, backgroundColor: "#e5e7eb" }),
                                multiValueLabel: (base) => ({ ...base, color: "#000" }),
                                multiValueRemove: (base) => ({ ...base, color: "#ff0000", cursor: "pointer" }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon className="text-white" onClick={openModal1} />
                            </button>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
                  <button className="first-btn" onClick={closeModal}>
                    Cancel
                  </button>
                  <button
                    disabled={isLoading}
                    className={
                      "second-btn " +
                      (isLoading &&
                        "opacity-50 animate-pulse cursor-not-allowed")
                    }
                    onClick={(e) => createFixedShift(e)}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="first-panel">
                <div className="h-[50vh] overflow-y-scroll">
                  <div className="relative flex justify-center items-center gap-2 pr-[10px] pl-[10px] w-full h-fit">
                    <p className="text-[13px] whitespace-nowrap">
                      Select Month
                    </p>
                    <input
                      type="month"
                      value={`${selectedMonth.getFullYear()}-${String(
                        selectedMonth.getMonth() + 1
                      ).padStart(2, "0")}`}
                      onChange={handleMonthChange}
                      className="bg-[#F4F5F9] p-[6px] border rounded-md focus-visible:outline-none w-[100%] lg:w-[240px] text-sm"
                    />
                    {openCalendar && (
                      <div className="top-10 z-10 absolute bg-white shadow-lg mt-1 border border-gray-300 rounded-md w-full">
                        <div className="p-3">
                          <div className="flex justify-between items-center mb-4">
                            <button
                              onClick={() => handleYearChange(-1)}
                              className="p-1 focus:outline-none text-gray-600 hover:text-gray-900"
                            >
                              &lt;
                            </button>
                            <div className="font-semibold">{year}</div>
                            <button
                              onClick={() => handleYearChange(1)}
                              className="p-1 focus:outline-none text-gray-600 hover:text-gray-900"
                            >
                              &gt;
                            </button>
                          </div>
                          <div className="gap-2 grid grid-cols-3">
                            {months.map((row, rowIndex) =>
                              row.map((month, colIndex) => {
                                const monthIdx = rowIndex * 3 + colIndex;
                                const isSelected =
                                  selectedMonth.getMonth() === monthIdx &&
                                  selectedMonth.getFullYear() === year;

                                return (
                                  <button
                                    key={month}
                                    onClick={() => handleMonthSelect(monthIdx)}
                                    className={`py-2 text-sm font-medium rounded-md focus:outline-none ${isSelected
                                      ? "bg-[#27004a] text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                      }`}
                                  >
                                    {month}
                                  </button>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center items-center gap-4">
                    <h2 className="text-[14px]">Select All</h2>
                    <div className="mt-[6px] pl-[12px]">
                      {/* <Select
                        options={options}
                        isMulti
                        placeholder="Select Shift"
                        value={
                          flexibleDays?.length > 0
                            ? flexibleDays[0]?.shifts
                            : []
                        }
                        onChange={(selected) => {
                          setFlexibleDays(
                            daysInMonth.map((currentDay) => {
                              const date = new Date(
                                selectedMonth.getFullYear(),
                                selectedMonth.getMonth(),
                                currentDay
                              );
                              return {
                                day: new Date(date).toISOString(),
                                shifts: selected,
                                weekoff: false,
                              };
                            })
                          );
                        }}
                        onMenuOpen={() =>
                          selectedShift.length === 0 && openModal1()
                        }
                        className="bg-[#fff] p-[6px] rounded-md focus-visible:outline-none w-[100%] lg:w-[250px] text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "40px",
                            // maxHeight: '30px',
                            // overflow: "scroll",
                            // scrollBehavior: "smooth",
                            // scrollbarWidth: "none",
                            // overflowX: "hidden",
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e5e7eb",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#000",
                            // height: '30px',
                            // display:"flex",
                            // flexDirection:"column",
                            // justifyContent:"center",
                            // alignItems: 'center',
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#ff0000",
                            cursor: "pointer",
                          }),
                        }}
                      /> */}
                      <Select
                        options={options}
                        isMulti
                        placeholder="Select Shift"
                        value={
                          flexibleDays?.length > 0
                            ? flexibleDays[0]?.shifts
                            : []
                        }
                        onChange={(selected) => {
                          setFlexibleDays(
                            daysInMonth.map((currentDay) => {
                              const date = new Date(
                                selectedMonth.getFullYear(),
                                selectedMonth.getMonth(),
                                currentDay
                              );

                              const existingDay = flexibleDays.find(
                                (item) => item.day === date.toISOString()
                              );

                              return {
                                day: date.toISOString(),
                                shifts: existingDay?.weekOff ? existingDay.shifts : selected, // Sunday ko select hone se roka
                                weekOff: existingDay?.weekOff || false,
                              };
                            })
                          );
                        }}
                        onMenuOpen={() =>
                          selectedShift.length === 0 && openModal1()
                        }
                        className="bg-[#fff] p-[6px] rounded-md focus-visible:outline-none w-[100%] lg:w-[250px] text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "40px",
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e5e7eb",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#000",
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#ff0000",
                            cursor: "pointer",
                          }),
                        }}
                      />

                    </div>
                  </div>
                  <table className="w-full">
                    <thead className="border-[#000] border-b">
                      <tr>
                        <th className="p-3 font-medium text-[13px]">Day</th>
                        <th className="flex items-center gap-[7px] p-3 w-[45px] font-medium text-[13px]">
                          Weekoff{" "}
                          <input
                            type="checkbox"
                            onChange={handleWeekoffToggle}
                          />
                        </th>
                        <th className="p-3 pl-[8px] font-medium text-[13px] text-center">
                          Shifts
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {daysInMonth?.map((day) => {
                        const date = new Date(
                          selectedMonth.getFullYear(),
                          selectedMonth.getMonth(),
                          day
                        );
                        const isSunday = date.getDay() === 0;
                        const updateWeekOff = flexibleDays.find(
                          (item) => item.day === date.toISOString()
                        );

                        return (
                          <tr key={date}>
                            <td className="font-normal text-[12px] text-center">
                              {`${date.toLocaleDateString("en-US", {
                                month: "short",
                              })} ${String(day).padStart(
                                1,
                                "0"
                              )} | ${getDayName(date)}`}
                            </td>
                            <td className="p-3 text-center">
                              <input
                                type="checkbox"
                                checked={updateWeekOff?.weekOff ?? false} // Sundays will be checked only when user clicks the weekoff checkbox
                                onChange={(e) => {
                                  if (updateWeekOff) {
                                    setFlexibleDays((prev) => [
                                      ...prev.filter(
                                        (item) =>
                                          item.day !== date.toISOString()
                                      ),
                                      {
                                        ...updateWeekOff,
                                        weekOff: !updateWeekOff.weekOff,
                                      },
                                    ]);
                                  } else {
                                    setFlexibleDays((prev) => [
                                      ...prev,
                                      {
                                        day: date.toISOString(),
                                        weekOff: true,
                                        shifts: [],
                                      },
                                    ]);
                                  }
                                }}
                              />
                            </td>
                            <td className="pr-5">
                              {updateWeekOff?.weekOff ? (
                                <div className="mt-1 mr-[0px] ml-[7px] p-[5px] border rounded-md focus:outline-none w-full text-[#000] text-[12px] xl:text-[14px]">
                                  Week Off
                                </div>
                              ) : (
                                <Select
                                  isDisabled={updateWeekOff?.weekOff}
                                  options={options}
                                  isMulti
                                  placeholder="Select Shift"
                                  value={updateWeekOff?.shifts || []}
                                  onChange={(selected) => {
                                    setFlexibleDays((prev) => [
                                      ...prev.filter(
                                        (item) =>
                                          item.day !== date.toISOString()
                                      ),
                                      {
                                        day: date.toISOString(),
                                        weekOff: false,
                                        shifts: selected,
                                      },
                                    ]);
                                  }}
                                  className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-full text-[#000] text-[12px] xl:text-[14px]"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: "40px",
                                    }),
                                    multiValue: (base) => ({
                                      ...base,
                                      backgroundColor: "#e5e7eb",
                                    }),
                                    multiValueLabel: (base) => ({
                                      ...base,
                                      color: "#000",
                                    }),
                                    multiValueRemove: (base) => ({
                                      ...base,
                                      color: "#ff0000",
                                      cursor: "pointer",
                                    }),
                                  }}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div class="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
                  <button class="first-btn" onClick={closeModal}>
                    Cancel
                  </button>
                  <button
                    disabled={isLoading}
                    className={
                      "second-btn " +
                      (isLoading &&
                        "opacity-50 animate-pulse cursor-not-allowed")
                    }
                    onClick={() => createFlexibleShift()}
                  >
                    Confirm{" "}
                  </button>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </Modal>
        {/* Week Off Modal */}
        <Modal
          isOpen={openWeekOff}
          onAfterOpen={() => {
            subtitle.style.color = "#000";
          }}
          onRequestClose={() => {
            setOpenWeekOff(false);
          }}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            {openWeekDay} - Week Offs
          </h2>
          <button
            onClick={() => setOpenWeekOff(false)}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div class="space-y-4 my-3 px-3">
            {[
              { key: "allweek", label: "All Week" },
              { key: "firstWeek", label: "1st Week" },
              { key: "secondWeek", label: "2nd Week" },
              { key: "thirdWeek", label: "3rd Week" },
              { key: "fourthWeek", label: "4th Week" },
              { key: "fifthWeek", label: "5th Week" },
            ].map((week) => {
              const currentDay = dayWiseWeekOff.find(
                (item) => item.day === openWeekDay.slice(0, 3)
              ); // Find the current day's weekOff data
              console.log(currentDay);
              return (
                <div
                  className="flex justify-between items-center space-x-2"
                  key={week.key}
                >
                  <label
                    htmlFor={week.key}
                    className="font-medium text-black text-sm"
                  >
                    {week?.label}
                  </label>
                  <input
                    type="checkbox"
                    id={week.key}
                    checked={currentDay ? currentDay.weekOff[week.key] : false} // Ensure we check for `currentDay`
                    onChange={(e) =>
                      handleDayWeekOffChange(
                        openWeekDay.slice(0, 3),
                        week?.key,
                        !currentDay?.weekOff[week.key]
                      )
                    }
                    className="w-4 h-4"
                  />
                </div>
              );
            })}
          </div>
          <div class="sm:flex sm:flex-row-reverse bg-gray-50 px-4 sm:px-6 py-3 rounded-b-lg">
            <button
              onClick={() => {
                setOpenWeekOff(false);
              }}
              id="confirmBtn"
              class="inline-flex justify-center bg-[#27004a] shadow-sm sm:ml-3 px-4 py-2 border border-transparent rounded-md focus:outline-none w-full sm:w-auto font-medium text-white sm:text-sm text-base"
            >
              Confirm
            </button>
            <button
              onClick={() => {
                console.log(dayWiseWeekOff);
                setOpenWeekOff(false);
              }}
              id="cancelBtn"
              class="inline-flex justify-center bg-white hover:bg-gray-50 shadow-sm mt-3 sm:mt-0 sm:ml-3 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 w-full sm:w-auto font-medium text-gray-700 sm:text-sm text-base"
            >
              Cancel
            </button>
          </div>
        </Modal>
        {/* update work timing */}

        <Modal
          isOpen={modalIsOpen1}
          onAfterOpen={afterOpenModal1}
          onRequestClose={closeModal1}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-b-1 text-[13px] xl:text-[15px]"
          >
            {openWeekDay} Shifts
          </h2>
          <button
            onClick={closeModal1}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="">
            {/* {
                        shiftDetails?.map((op,index)=>{
                            return  <div className='flex justify-between items-center px-3 py-3 border-b'>
                            <h3 className='text-[13px]'>{op.shiftName} | {op.shiftStartTime} - {op.shiftEndTime} </h3>
                            <input type="checkbox" value={selectedShift.filter(s=>s.id == op.id)[0]??false} onChange={(e)=>setSelectedShift((prev)=>{
                                return [...prev , ...shiftDetails?.filter((opt)=>opt.id===op.id)]
                            })}/>
                        </div>
                        })
                    } */}

            <div className="max-h-[100px] overflow-y-scroll">
              {shiftDetails?.map((op) => (
                <div
                  key={op.id}
                  className="flex justify-between items-center px-3 py-3 border-b"
                >
                  <h3 className="text-[13px]">
                    {op.shiftName} | {op.shiftStartTime} - {op.shiftEndTime}
                  </h3>
                  <input
                    type="checkbox"
                    checked={isSelected(op.id)}
                    onChange={() => handleCheckboxChange(op)}
                  />
                </div>
              ))}
            </div>
            <Link
              to=""
              className="flex items-center mt-3 p-4 w-full font-medium text-[#27004a] text-[16px] xl:text-[15px]"
              onClick={openModal2}
            >
              <AddIcon /> Add Shift
            </Link>
            <br />
            <div className="flex justify-end items-center gap-[10px] pr-4 pb-3 text-end">
              <button className="first-btn" onClick={closeModal1}>
                Cancel
              </button>
              <button className="second-btn" onClick={closeModal1}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen2}
          onAfterOpen={afterOpenModal2}
          onRequestClose={closeModal2}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-b-1 text-[13px] xl:text-[15px]"
          >
            Add New Shifts
          </h2>
          <button
            onClick={closeModal2}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="">
            <div className="p-[10px] border border-t max-h-[300px] overflow-y-scroll modal-field">
              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift Name
              </label>
              <br />
              <input
                value={newShift?.shiftName}
                onChange={(e) =>
                  setNewShift({ ...newShift, shiftName: e.target.value })
                }
                type="text"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <br />
              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift Start Time
              </label>
              <br />

              <input
                type="time"
                onFocus={(e) => e.target.showPicker()} // Ensures time picker opens on click
                onChange={(e) => {
                  const selectedTime = handleTimeChange(e.target.value);
                  setNewShift({ ...newShift, shiftStartTime: selectedTime });
                }}
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer"
              />

              <br />
              <label className="font-medium text-[13px] xl:text-[14px]">
                Can Punch In
              </label>
              <br />
              <div className="flex justify-between">
                <Tabs className="w-full">
                  <TabList className="flex justify-between gap-[20px] w-full w-full">
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-full placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          value="ANYTIME"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              punchInType: e.target.value,
                            })
                          }
                          type="radio"
                          id="anytime"
                          name="select-timing"
                        />
                        <label
                          for="anytime"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Anytime
                        </label>
                        <br />
                      </div>
                    </Tab>
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-full placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          type="radio"
                          value="ADDLIMIT"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              punchInType: e.target.value,
                            })
                          }
                          id="limit"
                          name="select-timing"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Add Limit
                        </label>
                        <br />
                      </div>
                    </Tab>
                  </TabList>

                  <TabPanel></TabPanel>

                  <TabPanel>
                    <label className="font-medium text-[13px] xl:text-[14px]">
                      Allow Punch In
                    </label>
                    <br />
                    <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
                      <div className="flex items-center gap-2">
                        <input
                          value={newShift?.allowPunchInHours}
                          type="number"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              allowPunchInHours: Number(e.target.value),
                            })
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Hours
                        </label>
                        <br />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          value={newShift?.allowPunchInMinutes}
                          type="number"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              allowPunchInMinutes: Number(e.target.value),
                            })
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                        >
                          Minutes{" "}
                          <span className="pl-[10px] xl:pl-[15px]">
                            Before Shift Start Time
                          </span>
                        </label>
                        <br />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>

              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift End Time
              </label>
              <br />

              <input
                type="time"
                onFocus={(e) => e.target.showPicker()} // Ensures time picker opens on focus
                onChange={(e) =>
                  setNewShift({ ...newShift, shiftEndTime: e.target.value })
                }
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer"
              />

              <label className="font-medium text-[13px] xl:text-[14px]">
                Can Punch Out
              </label>
              <br />
              <div className="">
                <Tabs className="w-full">
                  <TabList className="flex justify-between gap-[20px] w-full w-full">
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          type="radio"
                          value="ANYTIME"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              punchOutType: e.target.value,
                            })
                          }
                          id="anytime1"
                          name="punching-timing"
                        />
                        <label
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                          for="anytime1"
                        >
                          Anytime
                        </label>
                        <br />
                      </div>
                    </Tab>
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          value="ADDLIMIT"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              punchOutType: e.target.value,
                            })
                          }
                          type="radio"
                          id="limit1"
                          name="punching-timing"
                        />
                        <label
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                          for="limit1"
                        >
                          Add Limit
                        </label>
                        <br />
                      </div>
                    </Tab>
                  </TabList>

                  <TabPanel></TabPanel>
                  <TabPanel>
                    <label className="font-medium text-[14px]">
                      Allow Punch Out
                    </label>
                    <br />
                    <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
                      <div className="flex items-center gap-2">
                        <input
                          value={newShift?.allowPunchOutHours}
                          type="number"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              allowPunchOutHours: Number(e.target.value),
                            })
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Hours
                        </label>
                        <br />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          value={newShift?.allowPunchOutMinutes}
                          type="number"
                          onChange={(e) =>
                            setNewShift({
                              ...newShift,
                              allowPunchOutMinutes: Number(e.target.value),
                            })
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                        >
                          Minutes{" "}
                          <span className="pl-[10px] xl:pl-[15px]">
                            Before Shift Start Time
                          </span>
                        </label>
                        <br />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
              <button className="first-btn" onClick={closeModal2}>
                Cancel
              </button>
              <button
                disabled={isLoading}
                className={
                  "second-btn " + (isLoading && "opacity-50 cursor-not-allowed")
                }
                onClick={submitShift}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        {/* onclick star timing ---- time modal */}
        <Modal
          isOpen={modalIsOpen3}
          onAfterOpen={afterOpenModal3}
          onRequestClose={closeModal3}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="mb-4 p-3 border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]"
          >
            Select Time
          </h2>
          <button
            onClick={closeModal3}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="">
            <table className="table-timing p-[10px] w-full">
              <tbody className="flex justify-center gap-[12px] w-full">
                <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                  <td className="">00</td>
                  <td>01</td>
                  <td>02</td>
                  <td>03</td>
                  <td>04</td>
                  <td>05</td>
                  <td>06</td>
                  <td>07</td>
                </tr>
                <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                  <td>00</td>
                  <td>01</td>
                  <td>02</td>
                  <td>03</td>
                  <td>04</td>
                  <td>05</td>
                  <td>06</td>
                  <td>07</td>
                </tr>
                <tr className="flex flex-col w-[100px]">
                  <td>AM</td>
                  <td>PM</td>
                </tr>
              </tbody>
              <h3 className="pt-[25px] pb-[25px] text-[13px] xl:text-[14px] text-center">
                Selected Time: 12:00 PM
              </h3>
            </table>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
              <button
                className="first-btn"
                onClick={() => {
                  closeModal3();
                }}
              >
                Cancel
              </button>
              <button className="second-btn">Okay</button>
            </div>
          </div>
        </Modal>
        {/* onclick star timing ---- time modal */}

        {/* onclick update attendance modal */}
        <Modal
          isOpen={modalIsOpen5}
          onAfterOpen={afterOpenModal5}
          onRequestClose={closeModal5}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Bulk Update Work Timings for All Staff
          </h2>
          <button
            onClick={closeModal5}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="pb-2">
            <div className="flex justify-between items-center bg-[#F0F6FE] p-[10px] pl-[20px] text-[13px] xl:text-[14px]">
              <h4 className="m-0">Allow punch in from Staff App</h4>
              <div className="flex items-center">
                <div
                  onClick={() =>
                    setToggleAllowPunchInMobile(!toggleAllowPunchInMobile)
                  }
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toggleAllowPunchInMobile ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toggleAllowPunchInMobile
                      ? "translate-x-6"
                      : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={selfie} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Selfie Attendance</h4>
              </div>
              <div className="flex items-center">
                <div
                  onClick={() =>
                    setToggleSelfieAttendance(!toggleSelfieAttendance)
                  }
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toggleSelfieAttendance ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toggleSelfieAttendance ? "translate-x-6" : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={qr} className="w-[25px] h-[25px]" />
                <h4 className="m-0">QR Attendance</h4>
              </div>
              <div className="flex items-center">
                <div
                  onClick={() => setToggleQRAttendance(!toggleQRAttendance)}
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toggleQRAttendance ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toggleQRAttendance ? "translate-x-6" : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={gps} className="w-[25px] h-[25px]" />
                <h4 className="m-0">GPS Attendance</h4>
              </div>
              <div className="flex items-center">
                <div
                  onClick={() => setToggleGPSAttendance(!toggleGPSAttendance)}
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toggleGPSAttendance ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toggleGPSAttendance ? "translate-x-6" : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="p-4 pl-5 border border-t-0 border-r-0 border-b border-l-0">
              <label className="font-medium text-[13px] xl:text-[14px]">
                Mark Attendance From
              </label>

              <div className="flex gap-[12px] pt-3">
                <div className="flex items-center gap-[10px] pt-2 pr-3 pb-2 pl-3 border rounded-md">
                  <input
                    onClick={(e) => setMarkLocation(e.target.value)}
                    type="radio"
                    id="foroffice"
                    name="office"
                    value="Office"
                  />
                  <label for="foroffice" className="text-[13px] xl:text-[14px]">
                    Office
                  </label>
                  <br />
                </div>
                <div className="flex items-center gap-[10px] pt-2 pr-3 pb-2 pl-3 border rounded-md">
                  <input
                    onClick={(e) => setMarkLocation(e.target.value)}
                    type="radio"
                    id="anywhere"
                    name="office"
                    value="Anywhere"
                  />
                  <label for="anywhere" className="text-[13px] xl:text-[14px]">
                    Anywhere
                  </label>
                  <br />
                </div>
              </div>
            </div>

            <div className="flex items-center gap-[14px] p-4 pl-5 border border-t-0 border-r-0 border-b border-l-0">
              <img src={biometric} />
              <div>
                <label className="font-medium text-[13px] xl:text-[14px]">
                  Biometric Devices
                </label>
                <br />
                <Link
                  to="/biometric"
                  className="text-[#27004a] text-[13px] xl:text-[14px] decoration-1 underline"
                >
                  Manage biometric devices
                </Link>
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
              <button
                className="first-btn"
                onClick={(e) => {
                  closeModal5();
                }}
              >
                Cancel
              </button>
              <button
                className={
                  "second-btn " + (isLoading && "opacity-50 cursor-not-allowed")
                }
                onClick={(e) => {
                  updateAttendanceMode(e);
                }}
              >
                Update Attendance Modes{" "}
              </button>
            </div>
          </div>
        </Modal>

        {/* onclick update attendance modal */}

        {/* when onclick update attendance modes for all staff */}

        <Modal
          isOpen={modalIsOpen6}
          onAfterOpen={afterOpenModal6}
          onRequestClose={closeModal6}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Bulk Update Work Timings for All Staff
          </h2>
          <button
            onClick={closeModal6}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="flex flex-col justify-center items-center gap-[10px] pt-[20px] pb-[20px]">
            <img src={rightimg} className="w-[65px]" />
            <h3 className="text-center">
              You have Successfully updated attendance modes
            </h3>
            <button
              className="second-btn"
              onClick={() => {
                closeModal6();
                closeModal5();
              }}
            >
              Okay
            </button>
          </div>
        </Modal>

        {/* when onclick update attendance modes for all staff */}
        {/* onclick update automation rules */}
        <Modal
          isOpen={modalIsOpen7}
          onAfterOpen={afterOpenModal7}
          onRequestClose={closeModal7}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Bulk Update Automation Rules for All Staff
          </h2>
          <button
            onClick={closeModal7}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="pb-2">
            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={selfie} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Auto Present at day start</h4>
              </div>
              <div className="flex items-center">
                <div
                  onClick={() => setToggleAutoPresent(!toggleAutoPresent)}
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${toggleAutoPresent ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${toggleAutoPresent ? "translate-x-6" : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={qr} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Present on Punch In</h4>
              </div>
              <div className="flex items-center">
                <div
                  onClick={() => setTogglePresentOnPunch(!togglePresentOnPunch)}
                  className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${togglePresentOnPunch ? "bg-[#27004a]" : "bg-gray-300"
                    }`}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${togglePresentOnPunch ? "translate-x-6" : "translate-x-0"
                      }`}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={gps} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Auto half day if late by</h4>
              </div>
              <div className="flex items-center">
                <button className="first-btn" onClick={openModal16}>
                  {autoHalfDay.hr === "" && autoHalfDay.min === ""
                    ? "Not Set"
                    : autoHalfDay.hr + ":" + autoHalfDay.min}
                </button>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={gps} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Mandatory half day hours</h4>
              </div>
              <div className="flex items-center">
                <button className="first-btn" onClick={openModal17}>
                  {mandatoryHalfDayHour.hr === "" &&
                    mandatoryHalfDayHour.min === ""
                    ? "Not Set"
                    : mandatoryHalfDayHour.hr + ":" + mandatoryHalfDayHour.min}
                </button>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[12px]">
                <img src={gps} className="w-[25px] h-[25px]" />
                <h4 className="m-0">Mandatory full day hours</h4>
              </div>
              <div className="flex items-center">
                <button className="first-btn" onClick={openModal18}>
                  {mandatoryFullDayHour.hr === "" &&
                    mandatoryFullDayHour.min === ""
                    ? "Not Set"
                    : mandatoryFullDayHour.hr + ":" + mandatoryFullDayHour.min}
                </button>
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
              <button className="first-btn" onClick={closeModal7}>
                Cancel
              </button>
              <button
                className={
                  "second-btn " + (isLoading && "opacity-50 cursor-not-allowed")
                }
                onClick={(e) => {
                  updateAttendanceAutomationRules(e);
                }}
              >
                Update Automation Rules{" "}
              </button>
            </div>
          </div>
        </Modal>

        {/* onclick update automation rules */}

        {/* when onclick update attendance mods for aall staff successfull msg */}
        <Modal
          isOpen={modalIsOpen8}
          onAfterOpen={afterOpenModal8}
          onRequestClose={closeModal8}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Bulk Update Work Timings for All Staff
          </h2>
          <button
            onClick={closeModal8}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="flex flex-col justify-center items-center gap-[10px] pt-[20px] pb-[20px]">
            <img src={rightimg} className="w-[65px]" />
            <h3 className="text-center">
              You have Successfully updated attendance modes
            </h3>
            <button
              className="second-btn"
              onClick={() => {
                closeModal8();
                closeModal7();
              }}
            >
              Okay
            </button>
          </div>
        </Modal>

        {/* when onclick update attendance mods for aall staff successfull msg */}

        {/* onclick autohalf day minutes  button */}

        <Modal
          isOpen={modalIsOpen16}
          onAfterOpen={afterOpenModal16}
          onRequestClose={closeModal16}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Auto half day if late by
          </h2>
          <button
            onClick={closeModal16}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[12px] pb-2">
            <label className="font-medium text-[13px] xl:text-[14px]">
              Select Duration
            </label>

            <div className="flex flex-row flex-row gap-[3px] xl:gap-[30px]">
              <div className="flex items-center gap-2">
                <input
                  value={autoHalfDay.hr}
                  onChange={(e) =>
                    setAutoHalfDay((prev) => {
                      return {
                        ...prev,
                        hr: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                >
                  Hours
                </label>
                <br />
              </div>
              <div className="flex items-center gap-2">
                <input
                  value={autoHalfDay.min}
                  onChange={(e) =>
                    setAutoHalfDay((prev) => {
                      return {
                        ...prev,
                        min: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                >
                  Minutes
                </label>
                <br />
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
              <button className="first-btn" onClick={closeModal16}>
                Turn Off
              </button>
              <button
                className="second-btn"
                onClick={() => {
                  closeModal16();
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        {/* onclick autohalf day minutes  button */}

        {/* onclick mandatory half day minutes  button */}

        <Modal
          isOpen={modalIsOpen17}
          onAfterOpen={afterOpenModal17}
          onRequestClose={closeModal17}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Mandatory half day hours
          </h2>
          <button
            onClick={closeModal17}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[12px] pb-2">
            <label className="font-medium text-[13px] xl:text-[14px]">
              Select Duration
            </label>

            <div className="flex flex-row gap-[3px] xl:gap-[30px] xl">
              <div className="flex items-center gap-2">
                <input
                  value={mandatoryHalfDayHour.hr}
                  onChange={(e) =>
                    setMandatoryHalfDayHour((prev) => {
                      return {
                        ...prev,
                        hr: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                >
                  Hours
                </label>
                <br />
              </div>
              <div className="flex items-center gap-2">
                <input
                  value={mandatoryHalfDayHour.min}
                  onChange={(e) =>
                    setMandatoryHalfDayHour((prev) => {
                      return {
                        ...prev,
                        min: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                >
                  Minutes
                </label>
                <br />
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
              <button className="first-btn" onClick={closeModal17}>
                Turn Off
              </button>
              <button className="second-btn" onClick={closeModal17}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        {/* onclick mandatory half day minutes  button */}

        {/* onclick mandatory full day minutes  button */}

        <Modal
          isOpen={modalIsOpen18}
          onAfterOpen={afterOpenModal18}
          onRequestClose={closeModal18}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-[#000] border-b text-[14px]"
          >
            Mandatory Full day hours
          </h2>
          <button
            onClick={closeModal18}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[12px] pb-2">
            <label className="font-medium text-[13px] xl:text-[14px]">
              Select Duration
            </label>

            <div className="flex flex-row gap-[3px] xl:gap-[30px]">
              <div className="flex items-center gap-2">
                <input
                  value={mandatoryFullDayHour.hr}
                  onChange={(e) =>
                    setMandatoryFullDayHour((prev) => {
                      return {
                        ...prev,
                        hr: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                >
                  Hours
                </label>
                <br />
              </div>
              <div className="flex items-center gap-2">
                <input
                  value={mandatoryFullDayHour.min}
                  onChange={(e) =>
                    setMandatoryFullDayHour((prev) => {
                      return {
                        ...prev,
                        min: e.target.value,
                      };
                    })
                  }
                  type="number"
                  className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                />
                <label
                  for="limit"
                  className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                >
                  Minutes
                </label>
                <br />
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
              <button className="first-btn" onClick={closeModal18}>
                Turn Off
              </button>
              <button className="second-btn" onClick={closeModal18}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen22}
          onAfterOpen={afterOpenModal22}
          onRequestClose={closeModal22}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-b-1 text-[13px] xl:text-[15px]"
          >
            Week Offs
          </h2>
          <button
            onClick={closeModal22}
            className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="">
            <div className="p-3">
              <div className="flex justify-between items-center py-2 border-b">
                <h4>All Weeks Off</h4>
                <input
                  type="checkbox"
                  checked={allWeeksSelected}
                  onChange={handleAllWeeksToggle}
                />
              </div>
              {Object.keys(weeks).map((week, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center py-2 border-b"
                >
                  <h4>{`${index + 1}${index === 0
                    ? "st"
                    : index === 1
                      ? "nd"
                      : index === 2
                        ? "rd"
                        : "th"
                    } Week`}</h4>
                  <input
                    type="checkbox"
                    checked={weeks[week]}
                    onChange={() => handleWeekToggle(week)}
                  />
                </div>
              ))}
              <div className="flex justify-end items-center gap-[10px] py-2 pr-4 pb-3 text-end">
                <button className="first-btn" onClick={closeModal22}>
                  Cancel
                </button>
                <button className="second-btn" onClick={handleConfirm2}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* onclick mandatory full day minutes  button */}
      </div>
    </>
  );
};

export default EditAttendanceDetail;